import React from 'react';
import { FILTER } from '@fiverr-private/listing_lib';
import type { FilterType } from '@fiverr-private/listing_types';
import Toggle from '../toggle';

interface OnlineNowToggleProps {
    filter: FilterType;
    source?: string;
    tooltip?: boolean;
    className?: string;
    onCustomChange?: (filter: Record<string, string | undefined>) => void;
}

export const OnlineNowToggle = ({ filter, ...rest }: OnlineNowToggleProps) => {
    if (!filter) {
        return null;
    }

    return (
        <Toggle
            selectedValue={FILTER.IS_SELLER_ONLINE.SELECTED_VALUE}
            title={'search_perseus.filters.global.is_seller_online.toggle_title'}
            text={'search_perseus.filters.global.is_seller_online.toggle_tooltip'}
            {...filter}
            {...rest}
        />
    );
};
